export default __webpack_public_path__ + "static/media/bg-how.0c0b5136.svg";